<form [formGroup]="userMoreDetails" id="user-more-details" (ngSubmit)=onSubmit(userMoreDetails)>
	<div class="d-flex flex-column justify-content-center text-center flex-column m-step-wrapper1 container" 
	[ngClass]="{'first-question' : !prevQID}">
		<questions-manager [(editQid)]="qID" [visibleQids]="visibleQids" [(editQuestion)]="editQuestion" 
		(editQuestionChange)="editQuestionChange($event)">
			<!-- question 1 -->
			<question [qID]="'1'">
				<h3>{{"USER_MORE_DETAILS.QUESTION1.QUESTION"|translate}}</h3>
				<div class="form-row">
					<!--birth date-->
					<div class="form-group col-12 col-md-3">
						<label>{{"USER_MORE_DETAILS.QUESTION1.BIRTH_DAY"|translate}}</label>								
						<div class="input-group m-datepicker" style="direction:ltr">
							<input class="form-control m-sm-form-control" 
							[minDate]="minBirthDate" 
							[maxDate]="maxBirthDate" 
							[firstDayOfWeek]=7 
							formControlName="birthDate"  
							placeholder="dd/mm/yyyy"
							name="d2" 
							ngbDatepicker 
							#d2="ngbDatepicker" 
							[attr.aria-label]="'USER_MORE_DETAILS.QUESTION1.BIRTH_DAY'|translate">
							<div class="input-group-append">
								<button class="" (click)="d2.toggle()" type="button">
									<i class="fa fa-calendar fa-lg" aria-hidden="true"></i>
								</button>
							</div>
						</div>
						<small class="m-error form-text" *ngIf="userMoreDetails.get('birthDate').hasError('required') && submitted">
							{{ 'COMMON.FIELD_REQUIRED' | translate }}
						</small>
						<small class="m-error form-text" *ngIf="userMoreDetails.get('birthDate').hasError('invalidDate') && !userMoreDetails.get('birthDate').hasError('required') && submitted">
							{{ 'COMMON.DATE_ERROR' | translate }}
						</small>
					</div>
					<!--status-->
					<div class="form-group col-12 col-md-3">
						<label>{{"USER_MORE_DETAILS.QUESTION1.MARITAL_STATUS"|translate}}</label>
						<select formControlName="maritalStatus" class="form-control m-sm-form-control" [attr.aria-label]="'USER_MORE_DETAILS.QUESTION1.MARITAL_STATUS'|translate">
							<option [value]="defaultValue">{{"USER_MORE_DETAILS.QUESTION1.MARITAL_STATUS_PH"|translate}}</option>
							<option *ngFor="let status of maritalStatus" [value]="status">{{status}}</option>
						</select>
						<small class="m-error form-text" *ngIf="userMoreDetails.get('maritalStatus').hasError('required') && submitted">
							{{ 'COMMON.FIELD_REQUIRED' | translate }}
						</small>
					</div>
					<!--chidren-->
					<div class="form-group col-12 col-md-3">
						<label>{{"USER_MORE_DETAILS.QUESTION1.CHILDREN_NUMBER"|translate}}</label>
						<select formControlName="childrenNumber" class="form-control m-sm-form-control" [attr.aria-label]="'USER_MORE_DETAILS.QUESTION1.CHILDREN_NUMBER'|translate">
							<option [value]="defaultValue">{{"USER_MORE_DETAILS.QUESTION1.CHILDREN_NUMBER_PH"|translate}}</option>
							<option *ngFor="let num of childrenNumber" [value]="num">{{num}}</option>
						</select>
						<small class="m-error form-text" *ngIf="userMoreDetails.get('childrenNumber').hasError('required') && submitted">
							{{ 'COMMON.FIELD_REQUIRED' | translate }}
						</small>
					</div>
					<!--education-->
					<div class="form-group col-12 col-md-3">
						<label>{{"USER_MORE_DETAILS.QUESTION1.EDUCATION"|translate}}</label>
						<select class="form-control m-sm-form-control" 
						formControlName="education" 
						(change)="onEducationChange($event.target.value)">
							<option [value]="defaultValue">{{ 'COMMON.SELECT_EDUCATION_PH' | translate }}</option>
							<option *ngFor="let educ of educationCombo" [value]="educ">{{educ}}</option>
						</select>
						<small class="m-error form-text" *ngIf="userMoreDetails.get('education').hasError('required') && submitted">
							{{ 'COMMON.FIELD_REQUIRED' | translate }}
						</small>
					</div>
		
				</div>
				<button type="submit" class="btn btn-primary" 
						[ngClass]="{'m-valid' : userMoreDetails.valid && qID=='1'}">
					{{"USER_MORE_DETAILS.QUESTION1.BUTTON"|translate}}
				</button>
			</question>
			<!-- question 2 -->
			<question [qID]="'2'">
				<h2>{{'USER_MORE_DETAILS.QUESTION2.QUESTION'|translate}}</h2>
				<div class="d-flex justify-content-center text-center">
					<box-selector formControlName="employmentStatus" 
					[options]="employmentStatusOptions" 
					(optionClicked)="onSubmit(userMoreDetails)" 
					[(selectedOption)]="selectedEmploymentStatus"></box-selector>
				</div>
			</question>
			
			<!--employee-->
			<question [qID]="'3.1-a'">
			    <div>
                    <h3>{{"USER_MORE_DETAILS.QUESTION3.QUESTION-3-1-a"|translate}}</h3>
                    <div class="form-group">
						<input type="text" 
						formControlName="employersCompanyName" class="m-form-control2 form-control"
						 placeholder="{{'USER_MORE_DETAILS.QUESTION3.PH-3-1-a'|translate}}">
						 <div class="m-error form-text" 
						 	*ngIf="userMoreDetails.get('employersCompanyName').hasError('required') && submitted">
						 	{{ 'COMMON.FIELD_REQUIRED' | translate }}
						</div>
						<div class="m-error form-text" 
							*ngIf="userMoreDetails.get('employersCompanyName').hasError('pattern') && submitted">
							{{ 'COMMON.GENERAL_PATTERN_ERROR' | translate }}
						</div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <button type="submit" class="btn btn-primary" 
                                [ngClass]="{'m-valid' : userMoreDetails.valid && qID=='3.1-a'}">
                                {{"COMMON.PROCEED"|translate}}
                        </button>
                    </div>
                </div>
			</question>
			<question [qID]="'3.1-b'">
				<h3>{{"USER_MORE_DETAILS.QUESTION3.QUESTION-3-1-b"|translate}}</h3>
				<div class="d-flex flex-column flex-md-row justify-content-center text-center">
					<div>
						<div class="mx-1 form-group">
							<input type="text" 
								formControlName="employersCompanyField" class="m-form-control2 form-control"
								placeholder="{{'USER_MORE_DETAILS.QUESTION3.PH-3-1-b1'|translate}}">
							<div class="m-error form-text" 
								*ngIf="userMoreDetails.get('employersCompanyField').hasError('required') && submitted">
								{{ 'COMMON.FIELD_REQUIRED' | translate }}
							</div>
							<div class="m-error form-text" 
								*ngIf="userMoreDetails.get('employersCompanyField').hasError('pattern') && submitted">
								{{ 'COMMON.GENERAL_PATTERN_ERROR' | translate }}
							</div>
						</div>
						<div class="mx-1 form-group">
							<input type="text" 
								formControlName="employersProfession" class="m-form-control2 form-control"
								placeholder="{{'USER_MORE_DETAILS.QUESTION3.PH-profetional'|translate}}">
							<div class="m-error form-text" 
								*ngIf="userMoreDetails.get('employersProfession').hasError('required') && submitted">
								{{ 'COMMON.FIELD_REQUIRED' | translate }}
							</div>
							<div class="m-error form-text" 
								*ngIf="userMoreDetails.get('employersProfession').hasError('pattern') && submitted">
								{{ 'COMMON.GENERAL_PATTERN_ERROR' | translate }}
							</div>
						</div>
					</div>

					<div>
						<div class="mx-1 form-group">
							<input type="number" formControlName="employersCompanySeniority"
								class="m-form-control2 form-control" step="0.5" min="0.5" max="70"
								placeholder="{{'USER_MORE_DETAILS.QUESTION3.PH-3-1-b3'|translate}}">
							<div class="m-error form-text" *ngIf="userMoreDetails.get('employersCompanySeniority').hasError('required') && submitted">
								{{ 'COMMON.FIELD_REQUIRED' | translate }}
							</div>
							<div class="m-error form-text" *ngIf="userMoreDetails.get('employersCompanySeniority').hasError('pattern') && submitted">
								{{ 'USER_MORE_DETAILS.QUESTION3.PH-3-1-b3-valid' | translate }}
							</div>
						</div>
						<div class="mx-1 form-group">
							<input type="text" placeholder="{{'USER_MORE_DETAILS.QUESTION3.PH-3-2-yeshuv'|translate}}" aria-label="Number" matInput
								formControlName="yeshuvAvodaForEmployee" [matAutocomplete]="autoCityForEmployee"
								class="m-form-control2 form-control">
							<mat-autocomplete #autoCityForEmployee="matAutocomplete">
								<mat-option *ngFor="let city of  cityFilterListEmployee | async" [value]="city.name">
									{{ city.name }}
								</mat-option>
							</mat-autocomplete>
		
		
							<div class="m-error form-text"
								*ngIf="userMoreDetails.get('yeshuvAvodaForEmployee').hasError('required') && submitted">
								{{ 'COMMON.FIELD_REQUIRED' | translate }}
							</div>
							<div class="m-error form-text"
								*ngIf="userMoreDetails.get('yeshuvAvodaForEmployee').hasError('isNotInCityList') && !userMoreDetails.get('yeshuvAvodaForEmployee').hasError('required') && submitted">
								{{'COMMON.NOT_IN_LIST_ERROR' | translate}}
							</div>
		
						</div>
					</div>

				</div>
				<button type="submit" class="btn btn-primary" 
					[ngClass]="{'m-valid' : userMoreDetails.valid && qID=='3.1-b'}">
					{{"COMMON.PROCEED"|translate}}
				</button>
			</question>
			<question [qID]="'3.1-c'">
				<div>
					<h3>{{"USER_MORE_DETAILS.QUESTION3.QUESTION-3-1-c"|translate}}</h3>
					<div class="mx-1 form-group">
						<input formControlName="employersMonthlyIncome" 
						class="m-form-control2 form-control" 
						currencyMask type="tel" 
						placeholder="{{'USER_MORE_DETAILS.QUESTION3.PH-3-1-c'|translate}}">
						<div class="form-text m-error" 
						*ngIf="userMoreDetails.get('employersMonthlyIncome').hasError('required') && submitted">
							{{ 'COMMON.FIELD_REQUIRED' | translate }}
						</div>
					</div>
				</div>
				<div class="d-flex justify-content-center">
					<button type="submit" class="btn btn-primary"  
					[ngClass]="{'m-valid' : userMoreDetails.valid && qID=='3.1-c'}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
			</question>
			<!--end employee-->
			
			<!--independent-->
			<question [qID]="'3.2-a'">
				<div>
                    <h3>{{"USER_MORE_DETAILS.QUESTION3.QUESTION-3-2-a"|translate}}</h3>
                    <div class="form-group">
						<input type="text" 
						formControlName="independentCompanyName" class="m-form-control2 form-control"
						 placeholder="{{'USER_MORE_DETAILS.QUESTION3.PH-3-2-a'|translate}}">
						 <div class="m-error form-text" 
						 	*ngIf="userMoreDetails.get('independentCompanyName').hasError('required') && submitted">
						 	{{ 'COMMON.FIELD_REQUIRED' | translate }}
						</div>
						<div class="m-error form-text" 
							*ngIf="userMoreDetails.get('independentCompanyName').hasError('pattern') && submitted">
							{{ 'COMMON.GENERAL_PATTERN_ERROR' | translate }}
						</div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <button type="submit" class="btn btn-primary" 
                                [ngClass]="{'m-valid' : userMoreDetails.valid && qID=='3.2-a'}">
                                {{"COMMON.PROCEED"|translate}}
                        </button>
                    </div>
                </div>	
			</question>
			<question [qID]="'3.2-b'">
				<h3>{{"USER_MORE_DETAILS.QUESTION3.QUESTION-3-2-b"|translate}}</h3>
				<div class="d-flex flex-column flex-md-row justify-content-center text-center">
					<div>
						<div class="mx-1 form-group">
							<input type="text" 
								formControlName="independentCompanyField" class="m-form-control2 form-control"
								placeholder="{{'USER_MORE_DETAILS.QUESTION3.PH-3-2-b1'|translate}}">
							<div class="m-error form-text" 
								*ngIf="userMoreDetails.get('independentCompanyField').hasError('required') && submitted">
								{{ 'COMMON.FIELD_REQUIRED' | translate }}
							</div>
							<div class="m-error form-text" 
								*ngIf="userMoreDetails.get('independentCompanyField').hasError('pattern') && submitted">
								{{ 'COMMON.GENERAL_PATTERN_ERROR' | translate }}
							</div>
						</div>
						<div class="mx-1 form-group">
							<input type="text" 
								formControlName="independentProfession" class="m-form-control2 form-control"
								placeholder="{{'USER_MORE_DETAILS.QUESTION3.PH-profetional'|translate}}">
							<div class="m-error form-text" 
								*ngIf="userMoreDetails.get('independentProfession').hasError('required') && submitted">
								{{ 'COMMON.FIELD_REQUIRED' | translate }}
							</div>
							<div class="m-error form-text" 
								*ngIf="userMoreDetails.get('independentProfession').hasError('pattern') && submitted">
								{{ 'COMMON.GENERAL_PATTERN_ERROR' | translate }}
							</div>
						</div>
					</div>
					<div>
						<div class="mx-1 form-group">
							<input type="number" formControlName="independentCompanySeniority"
								class="m-form-control2 form-control" step="0.5" min="0.5" max="70"
								placeholder="{{'USER_MORE_DETAILS.QUESTION3.PH-3-2-b3'|translate}}">
							<div class="m-error form-text" *ngIf="userMoreDetails.get('independentCompanySeniority').hasError('required') && submitted">
								{{ 'COMMON.FIELD_REQUIRED' | translate }}
							</div>
							<div class="m-error form-text" *ngIf="userMoreDetails.get('independentCompanySeniority').hasError('pattern') && submitted">
								{{ 'USER_MORE_DETAILS.QUESTION3.PH-3-1-b3-valid' | translate }}
							</div>
						</div>
						<div class="mx-1 form-group">
							<input type="text" placeholder="{{'USER_MORE_DETAILS.QUESTION3.PH-3-2-yeshuv'|translate}}" aria-label="Number" matInput
								formControlName="yeshuvAvodaForIndependent" [matAutocomplete]="autoCityForIndependent"
								class="m-form-control2 form-control">
							<mat-autocomplete #autoCityForIndependent="matAutocomplete">
								<mat-option *ngFor="let city of  cityFilterListForIndependent | async" [value]="city.name">
									{{ city.name }}
								</mat-option>
							</mat-autocomplete>
		
		
							<div class="m-error form-text"
								*ngIf="userMoreDetails.get('yeshuvAvodaForIndependent').hasError('required') && submitted">
								{{ 'COMMON.FIELD_REQUIRED' | translate }}
							</div>
							<div class="m-error form-text"
								*ngIf="userMoreDetails.get('yeshuvAvodaForIndependent').hasError('isNotInCityList') && !userMoreDetails.get('yeshuvAvodaForIndependent').hasError('required') && submitted">
								{{'COMMON.NOT_IN_LIST_ERROR' | translate}}
							</div>
		
						</div>
					</div>
				</div>
				<button type="submit" class="btn btn-primary" 
					[ngClass]="{'m-valid' : userMoreDetails.valid && qID=='3.2-b'}">
					{{"COMMON.PROCEED"|translate}}
				</button>
			</question>
			<question [qID]="'3.2-c'">
				<div>
					<h3>{{"USER_MORE_DETAILS.QUESTION3.QUESTION-3-2-c"|translate}}</h3>
					<div class="mx-1 form-group">
						<input formControlName="independentYearlyIncome" 
						class="m-form-control2 form-control" 
						currencyMask type="tel" 
						placeholder="{{'USER_MORE_DETAILS.QUESTION3.PH-3-2-c'|translate}}">
						<div class="form-text m-error" 
						*ngIf="userMoreDetails.get('independentYearlyIncome').hasError('required') && submitted">
							{{ 'COMMON.FIELD_REQUIRED' | translate }}
						</div>
					</div>
				</div>
				<div class="d-flex justify-content-center">
					<button type="submit" class="btn btn-primary"  
					[ngClass]="{'m-valid' : userMoreDetails.valid && qID=='3.2-c'}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
			</question>
			<!--end independent-->

			<!-- question 4 -->
			<question [qID]="'4'">
				<h3>{{"USER_MORE_DETAILS.QUESTION4.QUESTION"|translate}}</h3>
				<div class="btn-group-toggle" data-toggle="buttons">
					<label class="btn btn-primary" 
					[ngClass]="{'selected':userMoreDetails.get('areThereOtherIncome').value==='YES'}">
						{{"COMMON.YES"|translate}}
						<input type="radio" 
						formControlName="areThereOtherIncome" 
						value="YES" (change)="onSubmit(userMoreDetails)" click2change>
					</label>
					<label class="btn btn-primary" 
					[ngClass]="{'selected':userMoreDetails.get('areThereOtherIncome').value==='NO'}">
						{{"COMMON.NO"|translate}}
						<input type="radio" formControlName="areThereOtherIncome" value="NO" 
						(change)="onSubmit(userMoreDetails)" click2change>
					</label>
				</div>
			</question>

			<!-- question 4.1 -->
			<question [qID]="'4-1'">
					<h3>{{"USER_MORE_DETAILS.QUESTION4-1.QUESTION"|translate}}</h3>
					<app-incomes-array 
						formArrayName="otherIncome" 
						(onAddFormGroup)="setValidators()" 
						[needSources]="true" 
						(onIncomesChange)="setValidators()" 
						[incomeTypes]="typeCmbo" 
						[incomesFormArray]="userMoreDetails.get('otherIncome')"
						[displayErrors]="submitted" [titles]="['USER_MORE_DETAILS.QUESTION4-1.LABEL1', 'USER_MORE_DETAILS.QUESTION4-1.LABEL2', 'USER_MORE_DETAILS.QUESTION4-1.LABEL3']" 
						[ph]="['USER_MORE_DETAILS.QUESTION4-1.LABEL1_PH' | translate,'USER_MORE_DETAILS.QUESTION4-1.LABEL3_PH' | translate]"
						[buttons]="['USER_MORE_DETAILS.QUESTION4-1.BUTTON_ADD','USER_MORE_DETAILS.QUESTION4-1.BUTTON_ADD_AND_SAVE']">
					</app-incomes-array>
					<button type="submit" class="btn btn-primary" 
					[ngClass]="{'m-valid' : userMoreDetails.valid && qID=='4.1'}">{{"COMMON.BUTTON_SAVE"|translate}}</button>
					<div class="d-flex justify-content-center text-center">
					</div>
			</question>
			
		</questions-manager>
	</div>
</form>



// WEBPACK FOOTER //
// ./src/app/user-more-details/user-more-details.component.html